import { render } from "./ggjxgrycgbd.vue?vue&type=template&id=8d6d721e&scoped=true&ts=true"
import script from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"
export * from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"

import "./ggjxgrycgbd.vue?vue&type=style&index=0&id=8d6d721e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6d721e"]])

export default __exports__